import TrainingObjectives from "./TrainingObjectives";

export default TrainingObjectives;
